import { RouteType } from "types/RouteType";
import LaborTimeTrackingWorkflowStore from "./LaborTimeTrackingWorkflowStore";

const LaborTimeTrackingWorkflowRoute: RouteType = {
  name: "Labor Time Tracking Workflow",
  path: "/workflows/labor-time-tracking",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Labor Time Tracking",
      component: () => import("./LaborTimeTrackingWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./LaborTimeTrackingWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.laborTimeTrackingWorkflowStore) {
      rootStore.laborTimeTrackingWorkflowStore = new LaborTimeTrackingWorkflowStore(
        rootStore
      );
    }
    const store = rootStore.laborTimeTrackingWorkflowStore as LaborTimeTrackingWorkflowStore;
    await store.loadInitialData();
    return true;
  },
};

export default LaborTimeTrackingWorkflowRoute;